import { render, staticRenderFns } from "./Advertisements.vue?vue&type=template&id=bb6eccb6&scoped=true&lang=pug"
import script from "./Advertisements.vue?vue&type=script&lang=js"
export * from "./Advertisements.vue?vue&type=script&lang=js"
import style0 from "./Advertisements.vue?vue&type=style&index=0&id=bb6eccb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6eccb6",
  null
  
)

export default component.exports